module.exports = __webpack_public_path__ + "produce-fresh-grass-17.jpg?4b2f8e66e8073a7c5b00dbeeb42c4a16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-17.jpg
// module id = 54
// module chunks = 0